import React, { useState } from 'react';

import Icon from 'components/DesignSystem/Icon';
import Sparkline from 'components/Flux/Automatic/Classic/Mobile/SystemCards/Sparkline';
import WeeklyBars from 'components/Flux/Automatic/Classic/Mobile/SystemCards/WeeklyBars';
import { SUBSYSTEM_NAMES } from 'constants/subsystemNames';
import { ClassicCard } from 'helper/flux/classicCards';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface SystemCardProps {
  card: ClassicCard;
}

const integer = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const percent = new Intl.NumberFormat('pt-BR', { style: 'percent', maximumFractionDigits: 1 });

export default function SystemCard({ card }: SystemCardProps) {
  const [open, setOpen] = useState(false);
  const description = SUBSYSTEM_NAMES[card.label];

  return (
    <div className="system-card">
      <button
        type="button"
        className="system-card-header"
        aria-expanded={open}
        onClick={() => setOpen((previous) => !previous)}
      >
        <span className="system-card-identity">
          <span className="system-card-label">{card.label}</span>
          {description && <span className="system-card-description">{description}</span>}
        </span>
        <span className="system-card-headline">
          <span className="system-card-percent">
            {card.monthPercentMLT === null ? '—' : percent.format(card.monthPercentMLT)}
          </span>
          <span className="system-card-percent-caption">da MLT</span>
        </span>
        <Icon iconType={open ? 'up_arrow' : 'down_arrow'} color={cssVar('text-muted')} size="small" />
      </button>

      <Sparkline values={card.weeks.map((week) => week.value)} />

      <div className="system-card-chips">
        <span className="system-card-chip">
          Mês
          {' '}
          <strong>{card.monthMWmed === null ? '—' : integer.format(card.monthMWmed)}</strong>
          {' '}
          MWmed
        </span>
        <span className="system-card-chip">
          MLT
          {' '}
          <strong>{card.mltMWmed === null ? '—' : integer.format(card.mltMWmed)}</strong>
          {' '}
          MWmed
        </span>
      </div>

      {open && (
        <div className="system-card-weekly">
          <span className="system-card-weekly-title">Prévia semanal · MWmed (semop)</span>
          <WeeklyBars weeks={card.weeks} />
        </div>
      )}
    </div>
  );
}
